import { feedbacks, feedbackTagMappings, feedbackTags } from '../feedback'
import { describeTable } from './describeTable'

describeTable(feedbacks, {
  description: `Customer feedback (palaute) on one visit: a 1–5 star rating and optional free text, left by the customer through the feedback link sent after the job (notifications.notification_type='visit_feedback_request'). Roughly 166 per month in 2026 with an average of 4.92. One row per visit in practice; created_by_user_id is the customer (users row) who rated, not staff.
Attribute a rating to technicians via visit_attendees on visit_id (lead role first). Ratings ≤ 3 automatically open a follow-up task for the foreman. Tags (feedback_tag_mappings → feedback_tags) categorise what the feedback was about.`,
  columns: {
    visitId:
      'The rated visit. Join visits for date, service and property, visit_attendees for the technicians.',
    createdByUserId: 'The customer user who submitted the rating.',
    ratingValue: '1–5 stars; 5 = best.',
    description:
      'Free-text comment; NULL when the customer only clicked stars.',
  },
})

describeTable(feedbackTags, {
  description:
    'Vocabulary of feedback tags (e.g. praise for punctuality, cleanliness complaint) applied to feedback rows through feedback_tag_mappings. Small lookup table.',
  columns: {
    category: "Grouping of the tag: 'positive', 'negative' or 'neutral'.",
  },
})

describeTable(feedbackTagMappings, {
  description:
    'Many-to-many link between feedbacks and feedback_tags; one row per tag applied.',
})
